import { section as sectionData } from "shared/data/section";
import { theme } from "shared/lib/styles";

import type {
  Props as AdSlotProps,
  ConfigProps,
} from "scmp-app/components/advertisement/ad-slots/ad-slot";
import { TargetingPaidType } from "scmp-app/components/advertisement/ad-slots/types";

export const getDefaultSectionAdsConfigs = (sectionId: string, adZone = "default") => {
  const defaultAdSlotProps: ConfigProps = {
    targeting: {
      paid: TargetingPaidType.NotArticle,
      scsid: [sectionId],
    },
    withBackground: true,
    withLabel: true,
    withSticky: true,
    zone: adZone,
  };

  const configs: Array<[AdSlotProps | null, AdSlotProps | null, AdSlotProps]> = [
    // AD2
    [
      {
        ...defaultAdSlotProps,
        adUnit: "d_lrec1",
        breakpoint: theme.breakpoints.up("desktop"),
        sizes:
          sectionId === sectionData.olympic.entityId
            ? [
                [300, 250],
                [300, 600],
              ]
            : [[300, 250]],
        withBackground: sectionId !== sectionData.olympic.entityId,
        withLabelBackground: sectionId !== sectionData.olympic.entityId,
        withMaxContainerSize: sectionId !== sectionData.olympic.entityId,
        withSticky: sectionId !== sectionData.olympic.entityId,
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec1",
        breakpoint: theme.breakpoints.only("tablet"),
        sizes:
          sectionId === sectionData.olympic.entityId
            ? [
                [300, 250],
                [320, 480],
              ]
            : [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_banner1",
        breakpoint: theme.breakpoints.only("mobile"),
        sizes: [[300, 250]],
      },
    ],
    // AD3
    [
      sectionData.news.peopleAndCulture.entityId === sectionId
        ? null
        : {
            ...defaultAdSlotProps,
            adUnit: "d_lrec3",
            breakpoint: theme.breakpoints.up("desktop"),
            sizes:
              sectionId === sectionData.olympic.entityId
                ? [[300, 250]]
                : [
                    [300, 250],
                    [300, 600],
                  ],
            withBackground: sectionId === sectionData.olympic.entityId,
            withLabelBackground: sectionId === sectionData.olympic.entityId,
            withMaxContainerSize: sectionId === sectionData.olympic.entityId,
            withSticky: sectionId === sectionData.olympic.entityId,
          },
      sectionData.news.peopleAndCulture.entityId === sectionId
        ? null
        : {
            ...defaultAdSlotProps,
            adUnit: "m_lrec3",
            breakpoint: theme.breakpoints.only("tablet"),
            sizes:
              sectionId === sectionData.olympic.entityId
                ? [[300, 250]]
                : [
                    [300, 250],
                    [320, 480],
                  ],
          },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec1",
        breakpoint: theme.breakpoints.only("mobile"),
        sizes: [
          [300, 250],
          [320, 480],
        ],
      },
    ],
    // AD4
    [
      {
        ...defaultAdSlotProps,
        adUnit: "d_lrec3a",
        breakpoint: theme.breakpoints.up("desktop"),
        sizes:
          sectionId === sectionData.sport.entityId
            ? [
                [300, 250],
                [300, 600],
              ]
            : [[300, 250]],
        withBackground: sectionId !== sectionData.sport.entityId,
        withLabelBackground: sectionId !== sectionData.sport.entityId,
        withMaxContainerSize: sectionId !== sectionData.sport.entityId,
        withSticky: sectionId !== sectionData.sport.entityId,
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec3a",
        breakpoint: theme.breakpoints.only("tablet"),
        sizes:
          sectionId === sectionData.sport.entityId
            ? [
                [300, 250],
                [320, 480],
              ]
            : [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec3",
        breakpoint: theme.breakpoints.only("mobile"),
        sizes: [[300, 250]],
      },
    ],
    // AD5
    [
      {
        ...defaultAdSlotProps,
        adUnit: "d_lrec2",
        breakpoint: theme.breakpoints.up("desktop"),
        sizes: [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec2",
        breakpoint: theme.breakpoints.only("tablet"),
        sizes: [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec2",
        breakpoint: theme.breakpoints.only("mobile"),
        sizes: [
          [300, 250],
          [320, 480],
        ],
      },
    ],
    // AD6
    [
      {
        ...defaultAdSlotProps,
        adUnit: "d_lrec4",
        breakpoint: theme.breakpoints.up("desktop"),
        sizes: [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec4",
        breakpoint: theme.breakpoints.only("tablet"),
        sizes: [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec4a",
        breakpoint: theme.breakpoints.only("mobile"),
        sizes: [[300, 250]],
      },
    ],
    // AD7
    [
      {
        ...defaultAdSlotProps,
        adUnit: "d_lrec4a",
        breakpoint: theme.breakpoints.up("desktop"),
        sizes: [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec4a",
        breakpoint: theme.breakpoints.only("tablet"),
        sizes: [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec2",
        breakpoint: theme.breakpoints.only("mobile"),
        sizes: [
          [300, 250],
          [320, 480],
        ],
      },
    ],
  ];

  return configs;
};
